import { NotFoundError } from '@uploadcam/common';
import { PaymentMetadata, getPaymentMetadata } from './save-payment-metadata.interactor';

export class GetPaymentMetadataInteractor {
  constructor(private readonly storage: Storage) {}

  public execute(paymentIntentId: string): PaymentMetadata {
    const data = getPaymentMetadata(this.storage);

    if (!(paymentIntentId in data)) {
      throw new NotFoundError();
    }

    return data[paymentIntentId];
  }
}
